/* eslint-disable */
import { DashLeague, LineupInfo, PlayerList } from 'Components';
import { Images, NavLink, _ } from 'Helpers';
import { Component } from 'react';
import { Trans } from 'react-i18next';

class MyTeamRoster extends Component {
  constructor(props) {
    super(props);
    this.nodes = {}
    this._node = null;
    this.setInstance = this.setInstance.bind(this)
    this.state = {
      updateLineupInfo: new Date().valueOf(),
      updateLineupInfoLeague: new Date().valueOf(),
    }  
  }

  setNodeRef(provider, node) {
    if (node) {
      this.nodes[provider] = node
    }
  }

  setInstance(_node) {
    this._node = _node
    if (typeof this.props.getInstance === 'function') {
      this.props.getInstance({
        rosterFilterUpdate: this.rosterFilterUpdate
      })
    }
  }

  rosterFilterUpdate = (position) => {
    this.nodes.PlayerList.rosterFilterUpdate(position);
  }

  
  
  render() {
    const {
      user_join_count,
      IS_MYTEAM,
      IS_TRASFER,
      TRF,
      MYTEAM,
      lineup_master_id,
      PlayerListProps,
      LineupInfoProps,
      next_week,
      joined_week,
      last_week,
      active_week,
      team_info,
      SelectedWeek,
      TeamBudget,
      TotalBudget,
      goToTW,
      contestData
    } = this.props
    let  cWeek = SelectedWeek;
    let scoring_weeks  = team_info?.scoring_weeks || []
    const totalTransfers = scoring_weeks.reduce((sum, item) => {
        return sum + Number(item.total_transfer);
    }, 0);
   
    
   const weekData = scoring_weeks.find(item => item.week === cWeek);

    const { updateLineupInfoLeague } = this.state
    const AllLeagueProps = {
      updateLineupInfo: updateLineupInfoLeague
    }

    
    
    return (
      <div className="roseter-child" ref={this.setInstance} >
        {/* My Team */}
        {
          (!_.isNull(user_join_count) && (IS_MYTEAM || MYTEAM)) &&
          <>
            {
              (
                (user_join_count == 1) &&
                (next_week > joined_week || active_week == last_week) && (IS_MYTEAM || MYTEAM) && joined_week
              ) &&
              <LineupInfo {...LineupInfoProps} />
            }
            {
              ((!lineup_master_id && (user_join_count == 0) || (next_week == joined_week)) && active_week != last_week) &&
              <PlayerList getInstance={this.setNodeRef.bind(this, 'PlayerList')} {...PlayerListProps} active_week={active_week} />
            }
            {(
              (user_join_count == 1) &&
              (next_week > joined_week || active_week == last_week) && (IS_MYTEAM || MYTEAM) && joined_week
            ) &&
              <>
                <div className='jl-txt'><Trans>Joined Leagues</Trans></div>
                <div className='joined-container dash-league-mtym'>
                  {/* <div className='classic-joined'><Trans>Classic Leagues</Trans>
                    <span><Trans>full Season</Trans></span>
                  </div> */}
                  <div className='title-joined'>
                    <span><Trans>League</Trans></span>
                    <span><Trans>Rank</Trans></span>
                  </div>
                  <div>
                    <DashLeague {...AllLeagueProps} />
                  </div>
                  <NavLink to='/leagues' className='spcl-prizes d-block' nw={true}><Trans>View Leagues</Trans> <i className='icon-back'></i> </NavLink>
                  {/* <div className='classic-joined'><Trans>Transfer & finance</Trans>
                    <span><Trans></Trans></span>
                  </div> */}
                </div>
              </>}
          </>
        }
        {(
              (user_join_count == 1) &&
              (next_week > joined_week || active_week == last_week) && (IS_MYTEAM || MYTEAM) && joined_week
            ) &&
          <div className='transfer-finance'>
          <div className='inner-header'><Trans>Transfer and Finance</Trans></div>
          <div className='points-block'>
              <div className='points-block-head'><Trans>Transfers</Trans></div>
              <div className='points-block-row'>
                <div className='points-block-lbl'><Trans>Gameweek Transfer</Trans></div>
                <div className='points-block-val'>{weekData?.total_transfer}</div>
              </div>
              <div className='points-block-row'>
                <div className='points-block-lbl'><Trans>Total Transfers</Trans></div>
                <div className='points-block-val'>{totalTransfers}</div>
              </div>
               <div className='points-block-head'><Trans>Finance</Trans></div>
              <div className='points-block-row'>
                <div className='points-block-lbl'><Trans>Team Budget</Trans></div>
                <div className='points-block-val'>{TotalBudget}</div>
              </div>
              <div className='points-block-row'>
                <div className='points-block-lbl'><Trans>In the bank</Trans></div>
                <div className='points-block-val'>{TeamBudget}</div>
              </div>
          </div>
          <div className={`transfer-finance-link ${contestData.dt_week == 0 ? 'disable' : ''}`} onClick={()=>goToTW()}>
            <img src={Images.TEAMOFWEEK} alt="" />
            <span><Trans>Check the Team of the Week</Trans></span>
            <i className='icon-back'></i>
          </div>
        </div>}

        {/* TRANSFER */}
        {
          //((!_.isNull(user_join_count) && (IS_TRASFER || TRF)) && lineup_master_id && joined_week) &&
          ((!_.isNull(user_join_count) && (IS_TRASFER || TRF))) &&
          <>
            <PlayerList getInstance={this.setNodeRef.bind(this, 'PlayerList')} {...PlayerListProps} active_week={active_week} />
          </>
        }
      </div>
    )
  }
}

export default MyTeamRoster;
